








































import Vue from 'vue';

// Services
import AnalyticService from '~/services/AnalyticService';
import DialogService from '~/services/DialogService';

// Utils
import { dateToStringRaw } from '~/utils/dateToString';
import { NodeType } from '~/services/types/resources';

import URLS from '~/URLS';

export default Vue.extend({
    name: 'FileListItem',
    props: {
        id: {
            type: String,
            default: '',
        },
        fileType: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        published: {
            type: String,
            default: '',
        },
        downloadUrl: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        thumbnail: {
            type: String,
            default: '',
        },
        content: {
            type: String,
            default: '',
        },
        nodeType: {
            type: String,
            default: '',
        },
        organizationId: {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        return {
            hasLoggedResourceNodeClickEvent: false,
        };
    },
    computed: {
        hasTooltip(): boolean {
            return !this.isNodeUrl() && this.description.trim() !== '';
        },
        tooltip(): string {
            return this.description;
        },
        toolTipTarget(): string {
            return 'tooltip_' + this.id;
        },
        isArticle() {
            return this.nodeType === NodeType.article;
        },
        isSubFolder() {
            return this.nodeType === NodeType.subFolder;
        },
    },
    methods: {
        getExtension(fileName: string) {
            const split = fileName.split('.');
            if (split.length > 1) {
                return split.pop() || '';
            } else {
                return '';
            }
        },
        getDate() {
            return dateToStringRaw(this.published);
        },
        click() {
            if (this.isNodeUrl()) {
                window.open(this.description, '_blank');
                return;
            }
            switch (this.nodeType) {
                case NodeType.article:
                    DialogService.openArticleDialog({
                        title: this.title,
                        body: this.content,
                    });
                    break;
                case NodeType.subFolder:
                    this.$router.push(`${URLS.resources}/${this.organizationId}/${this.id}`);
                    break;
                default:
                    window.open(this.linkUrl(), '_blank');
                    break;
            }
        },
        isNodeUrl() {
            return this.description !== undefined && this.isUrl(this.description);
        },
        isUrl(name: string) {
            return (
                name.toLowerCase().startsWith('http://') ||
                name.toLowerCase().startsWith('https://') ||
                name.toLowerCase().startsWith('mailto:')
            );
        },
        linkUrl() {
            if (this.isNodeUrl()) {
                return this.description;
            } else {
                return this.downloadUrl;
            }
        },
        nodeIcon() {
            if (this.isNodeUrl()) {
                return this.fileIcon('uri');
            } else if (this.isSubFolder) {
                return 'folder';
            } else {
                return this.fileIcon(this.getExtension(this.title));
            }
        },
        fileIcon(fileType: string): string {
            let icon = 'file-alt';
            switch (fileType) {
                case 'png':
                case 'jpeg':
                case 'bmp':
                case 'jpg':
                    icon = 'file-image';
                    break;
                case 'pdf':
                    icon = 'file-pdf';
                    break;
                case 'doc':
                case 'rtf':
                case 'docx':
                    icon = 'file-word';
                    break;
                case 'txt':
                    icon = 'file-alt';
                    break;
                case 'uri':
                    icon = 'link';
                    break;
                case 'ppt':
                case 'pptx':
                case 'potx':
                case 'potm':
                case 'sldx':
                    icon = 'file-powerpoint';
                    break;
                case 'xls':
                case 'xlsm':
                case 'xlsx':
                    icon = 'file-excel';
                    break;
                default:
                    break;
            }
            return icon;
        },
        async logResourceNodeClickEvent() {
            if (this.hasLoggedResourceNodeClickEvent || !this.id) return;
            AnalyticService.resourceNodeClickEvent(this.id);
            this.hasLoggedResourceNodeClickEvent = true;
        },
    },
});
